import React, { useMemo } from "react";
import { SimpleFieldProps } from "../types";
import FormField from "../FormField";
import classnames from "classnames";
import "./styles.scss";

export const CheckBox = ({
  t,
  field,
  register,
  touchedFields,
  errors,
  className: classNameProp,
  checkLabelClass,
}: SimpleFieldProps) => {
  const dataQA = `${field.type}-${field.name}`;
  const inputID = field.id || field.name;
  const classNames = classnames(`check`, {
    [field.class as string]: typeof field.class === "string" && field.class.length > 0,
    [classNameProp as string]: classNameProp,
  });

  const validate = !errors[field.name]; // If there are no errors, validation is successful
  const validField = touchedFields?.[field?.name] && !errors[field.name]; // Field is valid if no errors and has a value

  const checkLabel = t[field.label] || field.link;

  const buildedLabel = useMemo(() => {
    if (field.checkTitle) {
      return t[field.checkTitle];
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.checkTitle]);

  return (
    <FormField
      id={inputID}
      name={field.name}
      label={buildedLabel}
      className={classNames}
      helperMessage={
        (field.helperMessage && t[field.helperMessage]) || (field.help && t[field.help])
      }
      errorMessage={errors && errors[field.name] && t[errors[field.name]?.message as string]}
      disclaimerAfterField={field.disclaimer && t[field.disclaimer]}
      disclaimerAlert={field.disclaimerAlert && t[field.disclaimerAlert]}
      tooltip={field.tooltip && t[field.tooltip]}
      validate={validate}
      validField={validField}>
      <div className="check__wrapper">
        <input
          {...register(field.name, field.validation)}
          type="checkbox"
          id={field.name}
          data-qa={dataQA}
          data-testid="check-input"
          className="check__input"
        />

        {checkLabel && (
          <label
            className={checkLabelClass}
            htmlFor={inputID}>
            <span dangerouslySetInnerHTML={{ __html: checkLabel }} />
          </label>
        )}
      </div>
    </FormField>
  );
};

interface CheckboxSimpleProps {
  type: string;
  name: string;
  className?: string;
  checkTitle?: string;
  label?: string;
  link?: string;
  tooltip?: string;
  errorMessage?: string;
  validate?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
  checked: any;
  t: Record<string, string>;
}

export const CheckboxSimple = ({ name, checkTitle, label, onChange, t }: CheckboxSimpleProps) => {
  const inputID = name;

  return (
    <FormField
      id={inputID}
      name={name}
      label={checkTitle}
      className={"check"}>
      <div className="check__wrapper">
        <input
          type="checkbox"
          id={name}
          onChange={() => onChange}
          data-testid="check-input"
          className="check__input"
        />

        {label && (
          <label htmlFor={inputID}>
            <span dangerouslySetInnerHTML={{ __html: t[label] }} />
          </label>
        )}
      </div>
    </FormField>
  );
};
